import { Dialog } from 'primereact/dialog'
import React, { useContext, useEffect, useState } from 'react'
import { Button } from 'primereact/button'
import { CommonContext } from '../common/context/commonContext'
import { InventorySurveyDetailProps, InventorySurveyGoodsDetail } from '../../types/inventory'
import { getImageUrl } from '../../utils/imageUtils'
import { Image } from 'primereact/image'
import { includeComma, markDayHyphen } from '../../utils/inputText'
import { tokens } from 'locales/tokens'
import { useTranslation } from 'react-i18next'

const InventorySurveyDetailDialog = (props: InventorySurveyDetailProps) => {
    const { $toast, $http, $alert } = useContext(CommonContext)
    const { t } = useTranslation()
    const [inventoryGoodsAdjustmentVisible, setInventoryGoodsAdjustmentVisible] = useState<boolean>(false)

    const [goods, setGoods] = useState<InventorySurveyGoodsDetail>()

    useEffect(() => {
        if (props.inventoryGoods) {
            setGoods(props.inventoryGoods)
        }
    }, [props.inventoryGoods])

    const onClickAdjustmentOpen = () => {
        setInventoryGoodsAdjustmentVisible(true)
    }
    const onClickAdjustmentHide = (isChange: boolean) => {
        if (isChange) {
            props.onHide(true)
        }
        setInventoryGoodsAdjustmentVisible(false)
    }
    const onClickMoveOpen = () => {
        if (props.onHide) {
            props.onHide(true)
        }
    }
    const onClickSave = async () => {
        if (!props.inventoryGoods) return

        const isConfirm = await $alert({
            icon: 'info',
            title: t(tokens.common.add_zone),
            text: t(tokens.inventory.location_area_must_be_assigned),
            isConfirm: true,
        })

        if (!isConfirm) return

        const result = await $http().put('/inventory/add-area', {})
        if (result) {
            $toast({ title: t(tokens.common.success), text: t(tokens.inventory.zone_added), icon: 'success' })
            props.onHide(true)
        }
    }

    const header = () => {
        return (
            <>
                <div className="grid py-0">
                    <div>{props.locationDetail?.lctPathNm}</div>
                </div>
            </>
        )
    }

    const footer = () => {
        return (
            <div className="grid pt-4">
                <Button className="w-full p-3 m-0" label={t(tokens.common.enter_investigation_quantity)} size="large" onClick={onClickMoveOpen} />
            </div>
        )
    }

    return (
        <Dialog
            headerClassName="pb-3"
            header={header()}
            visible={props.visible}
            onHide={() => props.onHide(false)}
            contentClassName="pb-0"
            footer={footer}
        >
            {goods && (
                <div className="grid">
                    <div className="col-12 text-lg flex font-bold rdms-text-deepblue">{t(tokens.common.product_name)}</div>
                    <div className="col-12 text-lg flex font-semibold mt-0 pt-0">{goods.goodsNm}</div>
                    <div className="col-12 text-lg flex font-bold mt-2 rdms-text-deepblue">
                        {t(tokens.common.specification)} / {t(tokens.common.unit)}
                    </div>
                    <div className="col-12 text-lg flex font-semibold mt-0 pt-0">
                        {goods.specTxt} / {goods.gdslsUnitCd}{' '}
                    </div>
                    <div className="col-6 flex p-0">
                        <div className="col-12 text-lg flex font-bold mt-2 rdms-text-deepblue">
                            {t(tokens.inventory.existing_consumption_deadline)}
                        </div>
                    </div>
                    <div className="col-6 flex p-0">
                        <div className="col-12 text-lg flex font-bold mt-2 rdms-text-deepblue">{t(tokens.inventory.survey_consumption_deadline)}</div>
                    </div>
                    <div className="col-6 flex p-0">
                        <div className="col-12 text-lg flex font-semibold pt-0">
                            {markDayHyphen(goods.shlfYmd)}{' '}
                            {/*(D₩{moment().diff(goods.shlfYmd, 'days') > 0 ? '+' : '-'}{Math.abs(moment().diff(goods.shlfYmd, 'days'))})*/}
                        </div>
                    </div>
                    <div className="col-6 flex p-0">
                        <div className="col-12 text-lg flex rdms-text-danger font-semibold pt-0">{markDayHyphen(goods.invnsuShlfYmd as string)}</div>
                    </div>
                    <div className="col-6 flex p-0">
                        <div className="col-12 text-lg flex font-bold mt-2 rdms-text-deepblue">{t(tokens.inventory.existing_qty)}</div>
                    </div>
                    <div className="col-6 flex p-0">
                        <div className="col-12 text-lg flex font-bold mt-2 rdms-text-deepblue">{t(tokens.inventory.survey_qty)}</div>
                    </div>
                    <div className="col-6 flex p-0">
                        <div className="col-12 text-lg flex font-semibold pt-0">
                            {includeComma(goods.invnQty, '-')} {goods.gdslsUnitCd}
                        </div>
                    </div>
                    <div className="col-6 flex p-0">
                        <div className="col-12 text-lg flex rdms-text-danger font-semibold pt-0">
                            {includeComma(goods.invnsuQty, '-')} {goods.gdslsUnitCd}
                        </div>
                    </div>

                    <div className="col-12 p-align-center">
                        <Image className="flex align-items-center" src={getImageUrl(goods.imageUri)} width="90%" style={{ placeContent: 'center' }} />
                    </div>
                </div>
            )}
        </Dialog>
    )
}

export default InventorySurveyDetailDialog
